import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useWizard } from "../../context/WizardContext";
import { CurrencyInput } from "../shared/CurrencyInput";
import type { CostOfGoodsSold } from "../../types/business.types";

const COGS_FIELDS: { key: keyof CostOfGoodsSold; label: string }[] = [
  { key: "beginningInventory", label: "Inventory at beginning of year" },
  { key: "purchases", label: "Purchases (less personal use)" },
  { key: "costOfLabor", label: "Cost of Labor" },
  { key: "materialsAndSupplies", label: "Materials and Supplies" },
  { key: "otherCosts", label: "Other Costs" },
  { key: "endingInventory", label: "Inventory at end of year" },
];

export function BusinessStep4CostOfGoodsSold() {
  const { businessData, updateBusinessData } = useWizard();
  const cogs = businessData.costOfGoodsSold ?? {} as CostOfGoodsSold;

  const set = (patch: Partial<CostOfGoodsSold>) => {
    updateBusinessData({ costOfGoodsSold: { ...cogs, ...patch } });
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-foreground">Cost of Goods Sold</h2>
        <p className="text-sm text-muted-foreground">
          Enter amounts for inventory and costs. All fields are currency.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Cost of Goods Sold</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {COGS_FIELDS.map(({ key, label }) => (
            <CurrencyInput
              key={key}
              label={label}
              value={cogs[key]}
              onChange={(v) => set({ [key]: v } as Partial<CostOfGoodsSold>)}
            />
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
